import { useState } from 'react';
import type { ChangeEvent } from 'react';

export type BaseFilePickerInputStateAndHandlers = ReturnType<
  typeof useBaseFilePickerInputStateAndHandlers
>['baseFilePickerInputStateAndHandlers'];

type Args = {
  onFileSelected: (file: File) => unknown;
};

export function useBaseFilePickerInputStateAndHandlers({
  onFileSelected,
}: Args) {
  const [dragActive, setDragActive] = useState(false);
  const [mouseActive, setMouseActive] = useState(false);

  const onMouseEnter = () => {
    setMouseActive(true);
  };

  const onMouseLeave = () => {
    setMouseActive(false);
  };

  const onDragEnter = () => {
    setDragActive(true);
    setMouseActive(true);
  };

  const onDragEnd = () => {
    setDragActive(false);
    setMouseActive(false);
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDragActive(false);
    setMouseActive(false);

    const file = event.target.files?.[0];
    if (file) void onFileSelected(file);
  };

  const baseFilePickerInputStateAndHandlers = {
    dragActive,
    mouseActive,
    onMouseEnter,
    onMouseLeave,
    onDragEnter,
    onDragEnd,
    onChange,
  };

  return { baseFilePickerInputStateAndHandlers };
}
